import { AppManager } from '@common';
import * as PANOLENS from 'panolens';
import { textSpriteMaterial, textSpriteTexture } from '../utils/textSprite';
import BaseInteractiveSpot from './BaseInteractiveSpot';

const labelStyle = {
  fontSize: 50,
  fillStyle: 'rgba(255, 255, 255, 1.0)',
  backgroundColor: 'rgba(214, 0, 28, 1.0)',
  fixedWidth: 1300,
  fixedHeight: 70,
  textAlign: 'left',
};

export default class InfoMenuSpot extends BaseInteractiveSpot {
  constructor(panorama, menuConfig) {
    super(panorama);
    this.menuConfig = menuConfig;

    this.labelMesh = this.createLabel();
    this.panorama.addEventListener('change-language', this.onChangeLanguage.bind(this));
  }


  createLabel() {
    const texture = textSpriteTexture(this.menuLabel, labelStyle);
    const info = new PANOLENS.Infospot(200, texture, false, {
      onHoverStart: this.onHoverStart,
      onHoverEnd: this.onHoverEnd,
      onTouchStart: this.onTouchStart,
    });

    info.position.fromArray(this.menuConfig.position);
    info.addEventListener('click', this.onMenuClick.bind(this));
    info.name = `menulabel-${this.label}`;
    this.panorama.add(info);
    return info;
  }


  onMenuClick(event) {
    const { action } = this.menuConfig;
    this.actionHandler(action);
  }


  onChangeLanguage() {
    if (!this.labelMesh || !this.labelMesh.material) return;
    const material = textSpriteMaterial(this.menuLabel, labelStyle);
    this.labelMesh.material = material;
  }


  onHoverStart(info) {
    info.material.color.set('#bbb');
  }


  onHoverEnd(info) {
    info.material.color.set('#fff');
  }


  get menuLabel() {
    if (this.menuConfig['label_' + AppManager.currentLanguage]) {
      return this.menuConfig['label_' + AppManager.currentLanguage];
    }
    return this.menuConfig.label;
  }
}